export default {
    date: 'Date',
    speciality: 'Speciality',
    name: 'Name',
    description: 'Description',
}